import React, { useState } from "react";
import Modal from "../../../Korbantech/components/Modal";
import { CheckItem } from "../../CheckItem";
import { TermsForAccpet } from "../../TermsForAccept";

export const AceptTerms = () => {

    const [accept, setAccept] = useState<string>("");
    const [readAccept, setReadAcceot] = useState<boolean>(false);

    return (
        <div>
            Para finalizar seu cadastro 
            <strong className="text-primary-dark cursor-pointer ml-1"
                onClick={()=>setReadAcceot(true)}
            >clique aqui</strong>  e leia as
            condições do Programa Impulso e os termos do uso de dados e política 
            de privacidade
            <div className="flex my-1">
                <CheckItem
                    type="radio"
                    defaultChecked={accept === "y" ? true : false}
                    onClick={() => setAccept("y")}
                    name={accept==="y" ? "accept_term" : ""  }
                />
                Li e concordo com as condições do Programa Impulso, os termos do
                uso de dados e política de privacidade
            </div>
            <div className="flex">
                <CheckItem
                    type="radio"
                    defaultChecked={accept === "n" && true}
                    onClick={() => setAccept("n")}
                    name="other"
                />
                Não concordo com as condições do Programa Impulso, os termos do
                uso de dados e política de privacidade
            </div>
            {accept === "n" && (
                <div>
                    Atenção: Não será possível realizar seu cadastro no Programa
                    Impulso. Caso tenha dúvidas, por favor, envie um e-mail para
                    impulso@grpcom.com.br;
                </div>
            )}
            <div className="w-7/12">
                <Modal
                    open={readAccept}
                    onClickCloseButton={() => setReadAcceot(false)}
                >
                    <div className="flex flex-col">
                        <TermsForAccpet />
                        <button
                            className="bg-primary-dark p-3 rounded-md self-end"
                            onClick={() => setReadAcceot(false)}
                        >
                            Fechar termos
                        </button>
                    </div>
                </Modal>
            </div>
        </div>
    );
};
